import { render, staticRenderFns } from "./OvertimeRequest.vue?vue&type=template&id=68ab5e66&scoped=true"
import script from "./OvertimeRequest.vue?vue&type=script&lang=js"
export * from "./OvertimeRequest.vue?vue&type=script&lang=js"
import style0 from "./OvertimeRequest.vue?vue&type=style&index=0&id=68ab5e66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ab5e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
